import { Injectable } from '@angular/core';
import { IDataQuery, TableDesktopComponent, TableMobileComponent } from '@beego/ngx-table';
import { IDigibankAgency } from '@internal-models/digibank-agency.model';
import { DigibankAgencyProvider } from '@internal-providers/digibank-agency.provider';
import { Action, NavigationType } from '@shared-libs/enums';
import { MessageService } from '@shared-services/message.service';
import { NavigationService } from '@shared-services/navigation.service';
import { DigibankAgencyComponent } from '../digibank-agency-component/digibank-agency.component';

@Injectable()
export class DigibankAgenciesController {
	public digibankAgencies: Array<IDigibankAgency> = new Array();
	public tableComponent: TableDesktopComponent | TableMobileComponent;

	constructor(
		private readonly messageService: MessageService,
		private readonly navigationService: NavigationService,
		private readonly provider: DigibankAgencyProvider
	) {}

	public readonly dataRequest = (query: IDataQuery) => this.provider.getAllWithLimit(query);

	public dataChanged(digibankAgencies: Array<IDigibankAgency>): void {
		this.digibankAgencies = digibankAgencies;
	}

	public async openDigibankAgency(digibankAgency?: IDigibankAgency): Promise<void> {
		void this.navigationService
			.navigateTo<{ action: Action }>(NavigationType.modal, DigibankAgencyComponent, {
				digibankAgency,
				action: digibankAgency ? Action.UPDATE : Action.CREATE,
			})
			.then((result) => {
				if (result?.action) {
					this.tableComponent.refreshData();
					this.messageService.showSavedMessage();
				}
			})
			.catch();
	}
}
